<template>
  <div :style="{ 'max-height': '85vh' }">
    <v-card>
      <v-card-text
        class="overflow-y-auto"
        style="
          max-height: calc(85vh - 80px);
          padding-top: 40px;
          padding-bottom: 40px;
        "
      >
        <v-form ref="tagForm">
          <v-select
            v-model="tag.tagType"
            :items="tagTypes"
            class="body-2"
            item-text="type"
            style="width: 300px"
            item-value="value"
            dense
            single-line
          />
          <v-text-field
            v-model="tag.name"
            required
            :rules="[presenceValidation]"
          >
            <template v-slot:label>
              <InputLabel label-name="タグ名" :required="true" />
            </template>
          </v-text-field>
          <v-text-field
            v-model="tag.slug"
            hint="urlの名称になります。半角英字推奨"
            required
            :rules="[presenceValidation]"
          >
            <template v-slot:label>
              <InputLabel label-name="slug" :required="true" />
            </template>
          </v-text-field>
          <v-text-field v-model="tag.title">
            <template v-slot:label>
              <InputLabel label-name="英字タイトル" :required="false" />
            </template>
          </v-text-field>
          <TagSelector
            :tag="tag.parent"
            label="親タグ"
            :filter="selectableParentTagsFilter"
            @change-tag="setParentId"
          ></TagSelector>
          <v-switch
            v-model="tag.isTopLevel"
            persistent-hint
            class="p-settingForm--inputSwitch"
            hint="ヘッダーやサイドバーに優先的に表示されるようになります"
            label="トップレベルカテゴリに指定する"
          />
          <v-textarea
            v-model="tag.description"
            class="body-2"
            auto-grow
            label="説明"
          />
          <ImageFormAndThumbnail
            label-name="カバー画像"
            :propsImagePreviewURL="tag.coverImage ? tag.coverImage.url : ''"
            @change-image-file="(imageValue) => (tag.coverImage = imageValue)"
          ></ImageFormAndThumbnail>
          <v-text-field
            v-model="tag.priority"
            label="優先度"
            type="number"
            min="0"
            style="width: 110px"
            :rules="[positiveNumberPresenceValidation]"
          >
            <template v-slot:label>
              <InputLabel label-name="優先度" :required="true" />
            </template>
          </v-text-field>
          <v-alert dense outlined type="error" class="text-caption">
            ※1. 優先度は0が最高で、数が大きくなるほど低くなります<br />
            ※2. 優先度が高いほど、先頭で表示されます。
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="saveTag"> 保存する </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import ImageFormAndThumbnail from '@/components/commons/ImageFormAndThumbnail'
import formValidationUtils from '@/mixins/form_validation_utils'
import TagSelector from '@/components/commons/tags/TagSelector'

export default {
  name: 'TagForm',
  components: {
    InputLabel,
    ImageFormAndThumbnail,
    TagSelector
  },
  mixins: [formValidationUtils],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tag: {
        priority: 0
      },
      selectableParentTags: [],
      tagTypes: [
        { type: 'タグ', value: 'tag' },
        { type: 'カテゴリ', value: 'category' }
      ]
    }
  },
  watch: {
    value (newValue) {
      this.tag = { ...newValue }
      this.tag.parent = newValue.parent
      this.tag.coverImage = newValue.coverImage
    }
  },
  mounted () {
    this.tag = { ...this.value }
    this.tag.parent = this.value.parent
  },
  methods: {
    selectableParentTagsFilter (item, queryText, itemText) {
      return !!(
        (!this.tag || item.id !== this.tag.id) &&
        (item.id.toString() === queryText || itemText.includes(queryText))
      )
    },
    setParentId (value) {
      if (value && value.id !== this.tag.id) {
        this.tag.parentId = value.id
      } else {
        this.tag.parentId = null
      }
    },
    saveTag () {
      if (!this.$refs.tagForm.validate()) {
        return false
      }
      this.$emit('save', this.tag)
    }
  }
}
</script>
